import React from 'react';
import PropTypes from 'prop-types';

import './Button.css';

export const Button = ({ text, onClick }) => {
  return (
    <button className='button' onClick={onClick}>
      <b>{text}</b>
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func
};
